export default __webpack_public_path__ + "static/media/exclamation.7c163856.svg";